import * as React from 'react'

const HouseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.9712 9.45468L13.4759 2.37937L13.4609 2.36531C13.1164 2.05008 12.6664 1.87524 12.1995 1.87524C11.7325 1.87524 11.2825 2.05008 10.9381 2.36531L10.9221 2.37937L3.4287 9.45468C3.23867 9.6305 3.08697 9.84364 2.98308 10.0808C2.8792 10.3179 2.82536 10.5739 2.82495 10.8328V19.5C2.82495 19.9973 3.0225 20.4742 3.37413 20.8258C3.72576 21.1775 4.20267 21.375 4.69995 21.375H9.19995C9.69723 21.375 10.1741 21.1775 10.5258 20.8258C10.8774 20.4742 11.075 19.9973 11.075 19.5V15.375H13.325V19.5C13.325 19.9973 13.5225 20.4742 13.8741 20.8258C14.2258 21.1775 14.7027 21.375 15.2 21.375H19.7C20.1972 21.375 20.6741 21.1775 21.0258 20.8258C21.3774 20.4742 21.575 19.9973 21.575 19.5V10.8328C21.5745 10.5739 21.5207 10.3179 21.4168 10.0808C21.3129 9.84364 21.1612 9.6305 20.9712 9.45468ZM19.325 19.125H15.575V15C15.575 14.7538 15.5265 14.5099 15.4322 14.2825C15.338 14.055 15.1999 13.8483 15.0258 13.6742C14.8517 13.5001 14.645 13.362 14.4175 13.2677C14.19 13.1735 13.9462 13.125 13.7 13.125H10.7C10.2027 13.125 9.72576 13.3225 9.37413 13.6742C9.0225 14.0258 8.82495 14.5027 8.82495 15V19.125H5.07495V10.995L12.2 4.26843L19.325 10.995V19.125Z"
      fill="currentColor"
    />
  </svg>
)

export default HouseIcon
